import { ChangeDetectorRef, Component, ElementRef, OnInit, Renderer2, ViewChild, ViewChildren, QueryList, HostListener } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Sectors, User } from '@core/interfaces/user.model';
import { AuthService } from '@core/services/authentication/auth.service';
import { LocalStorageService } from '@core/services/local-storage.service';
import { AppState } from '@core/store/app.reducer';
import { Store } from '@ngrx/store';
import { catchError, debounceTime, distinctUntilChanged, map, Observable, of, shareReplay, Subscription, take } from 'rxjs';
import { Router } from '@angular/router';
import { MatSidenav } from '@angular/material/sidenav';
import { Categories_request, categories_response } from '@core/interfaces/categories';
import { CategoriesService } from '@core/services/categories/categories.service';
import { ProductsService } from '@core/services/products/products.service';
import { CarsState } from '@core/interfaces/cars';
import { ShowCarComponent } from './show-car/show-car.component';
import { ShowNotificationsComponent } from './show-notifications/show-notifications.component';
import * as launchersActions from '@core/store/launchers/launchers.actions'
import * as shoppingActions from '@core/store/shoppingCar/shoppingCar.actions'
import * as authActions from '@core/store/auth/auth.actions';
import { UtilsService } from '@core/services/utils/utils.service';
import { MatOptionSelectionChange } from '@angular/material/core';
import { AccountService } from '@core/services/account/account.service';
import { GtmEventService } from '@core/analytics/gtm-events.service';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import { CheckingAccountService } from '@core/services/checking-account/checking-account.service';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  readonly horizontalPosition: MatSnackBarHorizontalPosition = 'left';
  readonly verticalPosition: MatSnackBarVerticalPosition = 'bottom';
  @ViewChild("search_opacity")
  search_opacity!: ElementRef;
  @ViewChild('drawer')
  sidenav!: MatSidenav;
  @ViewChild('drawerCar') ViewCar!: MatSidenav;
  @ViewChild('drawerNotifications') drawerNotifications!: MatSidenav;
  panelClosingActions!: Observable<MatOptionSelectionChange | null>;
  readonly control = new FormControl();
  businessUnities: Array<Sectors> = [];
  businessUnitiesTrue: Array<Sectors> = [];
  unitSelect!: Categories_request;
  user!: User;
  iconProfileUser: any;
  listCategories: Array<categories_response> = [];
  readonly hidden = false;
  loadingSearch = false;
  errorSearch = false;
  searchResponse$ = of([]);
  searchTextValue = '';
  initialDateSearch = [];
  carsState!: CarsState;
  car!: any;
  badge = 0;
  readonly products: any[] = [];
  dataCurrentAccount: any;
  resAccounts: any;
  private carSubscription!: Subscription;
  typeUser: any;
  @ViewChildren('plot', { read: ElementRef }) el!: QueryList<ElementRef>;
  @ViewChild("appShowCar", { read: ShowCarComponent }) appShowCar!: ShowCarComponent
  @ViewChild(ShowCarComponent) showCarComponent!: ShowCarComponent;
  @ViewChild(ShowNotificationsComponent) showNotificationsComponent!: ShowNotificationsComponent;
  accountsSuscription$!: Subscription;
  isMobile = false;
  notificationCount = 0;
  isNotificationsOpen = false;
  readonly skeletonThemeWide = {
    height: '8px',
    width: '200px',
    'border-radius': '8px',
    display: 'flex',
    'align-items': 'center',
    'margin-bottom': '0px'
  };

  readonly skeletonThemeSmall = {
    height: '8px',
    width: '100px',
    'border-radius': '8px',
    display: 'flex',
    'align-items': 'center',
    'margin-bottom': '0px',
    'margin-top': '8px'
  };
  constructor(
    private readonly _authService: AuthService,
    private readonly _categoriesService: CategoriesService,
    private readonly _productsService: ProductsService,
    public readonly _localStorageService: LocalStorageService,
    private readonly store: Store<AppState>,
    private readonly router: Router,
    private readonly _accountService: AccountService,
    private readonly renderer: Renderer2,
    private readonly ref: ChangeDetectorRef,
    private readonly _gtmEventService: GtmEventService,
    private readonly _checkingAccountService: CheckingAccountService,
    private readonly _snackBar: MatSnackBar
  ) {
  }

  ngOnInit() {
    this.loadLocalData();
    this.initStore();
    this.initialData();
    this.getCheckingAccount();
    this.showMenu();
    this.checkMobile();
    // El badge se actualiza vía unreadCountChange del hijo (app-show-notifications)
  }

  get notificationBadgeLabel(): string {
    return this.notificationCount > 99 ? '99+' : String(this.notificationCount);
  }

  showMenu() {
    const userOptions = this._localStorageService.getItem('user').setting;
    const sector = this._localStorageService.getItem('sectorSelect');
    this.PROFILE_MENU_USER(userOptions, sector);
  }

  loadLocalData() {
    this.businessUnities = this._localStorageService.getItem('sectors');
    this.unitSelect = this._localStorageService.getItem('sectorSelect');
    this.user = this._localStorageService.getItem('user');
    const { sector, zone, schema, segment } = this.unitSelect;
    const data = {
      categoryCode: '002',
      brandCode: null,
      sector,
      zone,
      schema,
      segment,
      clientCode: this.user.code,
      userType: (this.user?.type === 'Cliente') ? 'C' : 'S'
    }
  }

  initStore() {
    this.store.select('auth').subscribe((authState) => {
      if (authState.user) {
        this.user = authState.user;
      }
    })
    this.carSubscription = this.store.select('carsState').subscribe((carsState) => {
      this.carsState = carsState;
      if (carsState) {
        const tempCar = carsState.cars.find((car) => (this.unitSelect && car.unitBussines == this.unitSelect.name))
        this.car = tempCar ? tempCar : undefined
        this.badge = this.car?.products ? this.car.products.length : 0;
      }
    })
  }

  initialData() {
    if (this.businessUnities) {
      this.businessUnitiesTrue = this.businessUnities?.filter(element => element.name !== this.unitSelect.name);
    }
    if (this.unitSelect) {
      this.getCategoriesList(this.unitSelect);
      this.getLaunches();
    }
  }

  clickMyAccount() {
    this._gtmEventService.clickMyAccountEvent();
  }

  selectOption(value) {
    //close car
    this.ViewCar.autoFocus = true;

    this.searchResponse$ = of([]);
    this.searchTextValue = '';
    this.listCategories = [];
    this.appShowCar.shouldScroll = true;
    this.dataCurrentAccount = null;

    if (this.businessUnitiesTrue) {
      this.businessUnitiesTrue = this.businessUnities.filter(element => element.name !== value.name);
      this.unitSelect = value;
      this._localStorageService.setItem('sectorSelect', this.unitSelect);
      this.selectAccount(value);
      // Add this line to update the menu
      this.PROFILE_MENU_USER(this._localStorageService.getItem('user').settings, value);
      this.businessUnitiesTrue = this.businessUnitiesTrue.map((element: Sectors) => {
        let temp: Sectors = {
          ...element,
          hover: false
        }
        return temp
      });
    }
    if (this.unitSelect) {
      this.getCategoriesList(this.unitSelect);
      this.initStore();
      this.loadLocalData();
      this.getLaunches();
      this.showNotificationsComponent?.loadNotifications();
    }
    this.showMenu();
    this.router.navigate(['/tienda'])
  }

  getLaunches() {

    let data = {
      "code": this.user.code,
      "sector": this.unitSelect.sector,
      "zone": this.unitSelect.zone,
      "schema": this.unitSelect.schema,
      "segment": this.unitSelect.segment,
    }
    // this._productsService.getLaunches(data).pipe(take(1)).subscribe({
    //   next: (res) => {
    //     this.store.dispatch(launchersActions.setLaunchers({ launchers: res ? res : [] }))

    //   },
    //   error: () => { },
    //   complete: () => { }
    // }
    // )
    
    // Dispatch con array vacío para mantener la funcionalidad del store
    this.store.dispatch(launchersActions.setLaunchers({ launchers: [] }))
  }
  getCategoriesList(data) {
    data.code = this.user.code;
    data.userType = this.user?.type == 'Cliente' ? 'C' : 'S';
    this._categoriesService.getCategories(data).pipe(take(1))
      .subscribe((res: any) => {
        this.listCategories = res;
      });
  }

  selectIconProfile(optionIcon) {
    switch (optionIcon) {
      case 'Mi avance mensual':
        this._gtmEventService.clickAdvanceSalesEvent();
        this.router.navigate(['/cuenta/avances-ventas']);
        break;
      case 'Imperdonables':
        this.router.navigate(['/cuenta/los-infaltables'], { queryParams: { tab: 'imperdonables' } });
        break;
      case 'Infaltables':
        this._gtmEventService.clickSalesAdvanceEvent();
        this.router.navigate(['/cuenta/los-infaltables'], { queryParams: { tab: 'infaltables' } });
        break;
      case 'Reconocimientos':
        this._gtmEventService.clickAwardsEvent();
        this.router.navigate(['/cuenta/reconocimientosdetalle']);
        break;
      case 'Pago de reconocimientos':
        this._gtmEventService.clickAwardsEvent();
        this.router.navigate(['/cuenta/reconocimientos']);
        break;
      case 'Historial de compras':
        this._gtmEventService.clickPurchaseHistoryEvent();
        this.router.navigate(['/cuenta/historial']);
        break;
      case 'Cuenta corriente':
        this._gtmEventService.clickCheckingAccountEvent();
        this.router.navigate(['/cuenta/facturacion']);
        break;
      case 'Comprobante electrónico':
        this._gtmEventService.clickElectronicReceiptEvent();
        window.open('http://asp401r.paperless.com.pe/PortalAlicorp/', "_blank", 'noopener');
        break;
      case 'Aliados Puntos':
        this._gtmEventService.clickAlliesEvent();
        this.router.navigate(['/cuenta/aliados']);
        break;
      case 'Acuerdos comerciales':
        this.router.navigate(['/cuenta/mis-acuerdos']);
        break;
        case 'Mis Reclamos':
        this.router.navigate(['/cuenta/mis-reclamos']);
        break;
      case 'Aliados Beneficios':
        this.router.navigate(['/cuenta/ali-socios']);
        break;
      case 'Cambiar contraseña':
        this._gtmEventService.clickPasswordChangeEvent();
        this.router.navigate(['/cuenta/perfil/credenciales']);
        break;
      case 'Cerrar sesión':
        this.logout();
        break;
      default:
        break;
    }
  }

  clickSearchBar() {
    this._gtmEventService.clickSearchBarEvent();
  }

  clickUploadOrder() {
    this._gtmEventService.clickUploadOrderEvent();
  }

  logout() {
    this.store.dispatch(authActions.unsetUser())
    this.store.dispatch(shoppingActions.unsetCar())
    this._authService.logout()
  }

  openCategories() {
    this.sidenav.toggle();
    this._gtmEventService.clickCategoriesEvent();
  }

  categoriesEmit(a) {
    this.sidenav.toggle();
    if (a.type == 'category') {
      this.router.navigate(['/tienda/busqueda'], { queryParams: { categoryCode: a.category.categoryCode, categoryName: a.category.categoryName } });
    } else {
      this.router.navigate(['/tienda/busqueda'], { queryParams: { categoryCode: a.category.categoryCode, categoryName: a.category.categoryName, brandCode: a.brandCode } });
    }
  }

  getList(text) {
    let data = this.unitSelect;
    data.code = this.user.code;
    data.description = text;
    data.userType = (this.user?.type === 'Cliente') ? 'C' : 'S';
    if (text && text.length >= 3 && text.length <= 50) {
      this.loadingSearch = true;
      this.errorSearch = false;
      this.searchResponse$ = this._categoriesService
        .getSearchCategories(data)
        .pipe(
          take(1),
          debounceTime(300),
          distinctUntilChanged(),
          // debounceTime(500),
          map((res) => {
            if (res) {
              this.loadingSearch = false;
              let resultado = res;
              if (res.length > 1) {
                const tieneActivos = res.some(item => !item.discontinued);
                if (tieneActivos) {
                  // Si hay productos activos, quitar todos los descontinuados
                  resultado = res.filter(item => !item.discontinued);
                } else {
                  // Todos están descontinuados, mantener solo el primero
                  resultado = [res[0]];
                }
              }

              this.saveInitialDate(res);

              if (resultado && resultado.length > 0) {
                this.addOpacityAutocomplete();
              } else {
                this.removeOpacityAutocomplete();
              }

              return resultado;
            } else {
              this.loadingSearch = false;
              this.errorSearch = false;
              this.saveInitialDate(res);
            }
          }),
          catchError((error) => {
            this.loadingSearch = false;
            this.errorSearch = true;
            return of([]);
          }),

        ), shareReplay(1) // para que la llamada se comparta y no se duplique
        ;
    } else {
      this.removeOpacityAutocomplete();
      this.searchResponse$ = of([]);
    }
  }

  mouseUp(event) {
    //vaciar data
    this.removeOpacityAutocomplete();
    if (event && event.length < 1) {
      this.searchResponse$ = of([]);
    }
  }

  saveInitialDate(response) {
    this.initialDateSearch = response;
  }

  mouseClickInput(text) {
    if (text && this.initialDateSearch && text.length >= 3 && this.initialDateSearch.length > 0) {
      this.addOpacityAutocomplete();
    }
    else {
      this.removeOpacityAutocomplete();
    }
  }

  searchEngineSelectedProduct(product: any) {
    const value = product?.sku;
    const description = product?.description ?? '';
    const gtmMeta = this._gtmEventService.buildPresentationMetaFromSearchAutocomplete(
      product,
      this.initialDateSearch || []
    );
    this._gtmEventService.clickSearchResultEvent(description, gtmMeta);
    if (gtmMeta) {
      this._gtmEventService.scheduleSkipViewSearchResultEventAfterAutocomplete();
    }
    this.initialDateSearch.forEach((item: any) => {
      item.select = item.sku === value ? true : false;
    });
    this._localStorageService.setItem('listProductSearch', this.initialDateSearch);
    this.router.navigate(['/tienda/busqueda'], { queryParams: { productos: value } });
    this.removeOpacityAutocomplete();
  }

  addOpacityAutocomplete() {
    this.renderer.addClass(this.search_opacity.nativeElement, "class-opacity");
    this.openedStart();
  }

  removeOpacityAutocomplete() {
    this.renderer.removeClass(this.search_opacity.nativeElement, "class-opacity");
    this.closedStart();
  }
  openedStart() {
    this.renderer.addClass(document.body, 'modal-open');
  }

  closedStart() {
    this.renderer.removeClass(document.body, 'modal-open');
    this.ViewCar.close();
  }
  countProduct(e) {
    const replace = e.e.replace(/[^0-9-.]/g, '');
    let countFormat = Number.parseFloat(replace)
    let tempCount: any = 0
    if (Number.isNaN(countFormat) || countFormat == 0) {
      tempCount = ''
      countFormat = 0
    } else if (countFormat < 0) {
      countFormat = countFormat * -1;
      tempCount = UtilsService.formatNumber(countFormat)
    }
    else if (countFormat > 999999) {
      tempCount = '999,999'
      countFormat = 999999
    } else {
      tempCount = UtilsService.formatNumber(countFormat)
    }
    this.searchAndModifyProduct(tempCount, countFormat, e.p)
    this.ref.detectChanges()
  }

  searchAndModifyProduct(value, inputValue, p) {
    const cars = this.carsState.cars.map((car) => {
      const products = car.products.map(product => {
        let totalPrice = product.totalPrice;
        if (product.sku == p.sku) {
          totalPrice = UtilsService.formatTotalNumber((inputValue * Number.parseFloat(p.salePrice)).toFixed(2))
          return {
            ...product,
            count: value,
            totalPrice: totalPrice
          }
        } else {
          return { ...product }
        }
      })
      return {
        ...car,
        products: products
      };
    })
    this.store.dispatch(shoppingActions.setCar({ cars }))
  }


  deleteProduct(p) {
    // Enriquecer el producto con item_list_name e item_list_id
    const enrichedProduct = {
      ...p,
      item_list_name: p.item_list_name || 'Generales',
      item_list_id: p.item_list_id || 'GENERAL',
    };
    
    // Crear los campos de precio específicos para el producto eliminado
    const priceFields = [{
      price: enrichedProduct.discountedPrice 
        ? this.currentToNumber(enrichedProduct.discountedPrice)
        : this.currentToNumber(enrichedProduct.salePrice),
      totalPrice: enrichedProduct.discountedPrice 
        ? Number.parseFloat((this.currentToNumber(enrichedProduct.discountedPrice) * this.currentToNumber(enrichedProduct.count)).toFixed(2))
        : Number.parseFloat((this.currentToNumber(enrichedProduct.salePrice) * this.currentToNumber(enrichedProduct.count)).toFixed(2)),
      discount: enrichedProduct.discountedPrice 
        ? Number.parseFloat((this.currentToNumber(enrichedProduct.salePrice) - this.currentToNumber(enrichedProduct.discountedPrice)).toFixed(2))
        : 0
    }];
    
    this._gtmEventService.deleteProductCarEvent("X", [enrichedProduct], priceFields);
    const cars = this.carsState.cars.map((car) => {
      const products = car.products.filter(product => product.sku != p.sku)
      return {
        ...car,
        products: products
      }
    })
    this.store.dispatch(shoppingActions.setCar({ cars }))
  }

  deleteCar() {
    // Obtener todos los productos del carrito actual para el evento
    const currentCar = this.carsState.cars.find(car => car.unitBussines == this.unitSelect.name);
    const productsToDelete = currentCar?.products || [];
    
    // Enriquecer los productos con item_list_name e item_list_id
    const enrichedProducts = productsToDelete.map(product => ({
      ...product,
      item_list_name: product.item_list_name || 'Generales',
      item_list_id: product.item_list_id || 'GENERAL',
    }));
    
    // Crear los campos de precio específicos para cada producto eliminado
    const priceFields = enrichedProducts.map(product => ({
      price: product.discountedPrice 
        ? this.currentToNumber(product.discountedPrice)
        : this.currentToNumber(product.salePrice),
      totalPrice: product.discountedPrice 
        ? Number.parseFloat((this.currentToNumber(product.discountedPrice) * this.currentToNumber(product.count)).toFixed(2))
        : Number.parseFloat((this.currentToNumber(product.salePrice) * this.currentToNumber(product.count)).toFixed(2)),
      discount: product.discountedPrice 
        ? Number.parseFloat((this.currentToNumber(product.salePrice) - this.currentToNumber(product.discountedPrice)).toFixed(2))
        : 0
    }));
    
    this._gtmEventService.deleteProductCarEvent("Vaciar carrito", enrichedProducts, priceFields);
    const cars = this.carsState.cars.map((car) => {
      if (car.unitBussines == this.unitSelect.name) {
        return {
          ...car,
          products: []
        }
      } else {
        return {
          ...car,
        }
      }
    })
    this.store.dispatch(shoppingActions.setCar({ cars }))
    this.ViewCar.toggle();
  }

  currentToNumber(current: any): number {
    if (current) {
      if (typeof current === 'string') {
        return Number(current.replace(/,/g, ''));
      } else if (typeof current === 'number') {
        return current;
      } else {
        throw new Error('Invalid input type');
      }
    } else {
      return 0;
    }
  }

  openCar() {
    this.showCarComponent.loadCar();
    this._gtmEventService.clickMyCarEvent();
    if (this.router.url != '/tienda/mi-carrito') {
      this.ViewCar.toggle();
      this.ViewCar.autoFocus = false;
    }
  }

  openNotifications() {
    this.isNotificationsOpen = !this.drawerNotifications?.opened;
    this.drawerNotifications?.toggle();
  }

  closeNotifications() {
    this.isNotificationsOpen = false;
    this.drawerNotifications?.close();
  }

  openSnackBar(text) {
    this._snackBar.open(text, 'Entendido', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      panelClass: ['snackBar-content'],
      duration: 5000,
    });
  }

  redirect() {
    this.router.navigate(['/tienda/mi-carrito'])
    this.closedStart();
  }

  selectConfirmation(stock: boolean) {
    stock && this.openSnackBar("Cambiaste las cantidades de tus productos, no olvides comprobar su disponibilidad.");
    this.redirect()
    this.ViewCar.close();
  }

  //obteniendo data de cuenta corriente para modal de carrito

  getCheckingAccount() {
    this.accountsSuscription$ = this._checkingAccountService
      .getCheckingAccount(this._localStorageService.getItem('user')?.code)
      .pipe(take(1))
      .subscribe({
        next: (res: any) => {
          if (res) {
            this.resAccounts = res.tCab;
            let valueSelect = this.resAccounts.filter(element => element.name === this.unitSelect?.name)
            this.selectAccount(valueSelect[0]);

          } else {
            this.resAccounts = null;
          }
        },
        error: (err: Error) => {
          this.resAccounts = null;
        },
      });

  }
  selectAccount(value) {
    if (this.resAccounts) {
      this.dataCurrentAccount = this.resAccounts.filter(element => element.name === value?.name);
    }

  }
  checkMobile() {
    // Define aquí el ancho máximo para considerar "mobile"
    const maxMobileWidth = 767;
    this.isMobile = window.innerWidth <= maxMobileWidth;
  }
  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.checkMobile();
  }

  getProductStatus(product: any): { class: string, text: string } | null {
    if (!product) return null;

    if (product.isRecommended) {
      return { class: 'new-label', text: '¡Nueva presentación!' };
    }

    if (product.discontinued && !product.newSku) {
      return { class: 'discontinued-label', text: 'Descontinuado' };
    }

    if (!product.discontinued && !!product.disableCode) {
      return { class: 'not-available-label', text: 'No disponible temporalmente' };
    }

    return null;
  }


  PROFILE_MENU_USER(value, sector) {
    //dinamico
    this.iconProfileUser = [
      { value_menu: value?.isAdvance, cardNew: true, name: 'Mi avance mensual', image: 'advance', hover: false },
      // { value_menu: true, cardNew: true, name: 'Imperdonables', image: 'unmissables', hover: false },
      // { value_menu: true, cardNew: true, name: 'Infaltables', image: 'essentials-medal', hover: false },
      { value_menu: value?.isBenefit, cardNew: true, name: 'Reconocimientos', image: 'reconocimiento', hover: false },
      { value_menu: true, cardNew: false, name: 'Pago de reconocimientos', image: 'reconocimiento', hover: false },
      { value_menu: true, cardNew: false, name: 'Historial de compras', image: 'historial', hover: false },
      { value_menu: true, cardNew: false, name: 'Cuenta corriente', image: 'account', hover: false },
      { value_menu: true, cardNew: false, name: 'Comprobante electrónico', image: 'comprobante', hover: false },
      { value_menu: (value?.isAlly && this._localStorageService.getItem('sectorSelect')?.sector == '0010'), cardNew: true, name: 'Aliados Puntos', image: 'allies', hover: false },
      { value_menu: true, cardNew: false, name: 'Acuerdos comerciales', image: 'trade-agreements', hover: false },
      { value_menu: true, cardNew: true, name: 'Mis Reclamos', image: 'my-clams', hover: false },
      { value_menu: (value?.isPartner && this._localStorageService.getItem('sectorSelect')?.sector == '0010'), cardNew: false, name: 'Aliados Beneficios', image: 'redirect-partners-ALI', hover: false },
      { value_menu: true, cardNew: false, name: 'Cambiar contraseña', image: 'change-password', hover: false },
      { value_menu: true, cardNew: false, name: 'Cerrar sesión', image: 'logout', hover: false },
    ]
  }
  unsubscribeFromStoreAccount() {
    if (this.accountsSuscription$) {
      this.accountsSuscription$.unsubscribe();
    }
  }
  ngOnDestroy(): void {
    this.carSubscription?.unsubscribe();
  }
}
